module.exports = __webpack_public_path__ + "img/fix_phone.87365f90.svg";